import script from "./WeChatLoginCallbackBridge.vue?vue&type=script&setup=true&lang=js"
export * from "./WeChatLoginCallbackBridge.vue?vue&type=script&setup=true&lang=js"

import "./WeChatLoginCallbackBridge.vue?vue&type=style&index=0&id=0ac84877&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ac84877"]])

export default __exports__